/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  TeamGroupModel,
  TeamModel,
  TeamModelBody,
  TeamsGetTeamParams,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useTeamsGetTeamsHook = () => {
  const teamsGetTeams = useCustomInstance<TeamModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return teamsGetTeams({
        url: `/api/Teams/GetTeams`,
        method: 'GET',
        signal,
      });
    },
    [teamsGetTeams]
  );
};

export const getTeamsGetTeamsQueryKey = () => {
  return [`/api/Teams/GetTeams`] as const;
};

export const useTeamsGetTeamsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamsHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamsHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTeamsGetTeamsQueryKey();

  const teamsGetTeams = useTeamsGetTeamsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamsHook>>>
  > = ({ signal }) => teamsGetTeams(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TeamsGetTeamsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamsHook>>>
>;
export type TeamsGetTeamsQueryError = unknown;

export const useTeamsGetTeams = <
  TData = Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamsHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamsHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useTeamsGetTeamsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTeamsGetTeamHook = () => {
  const teamsGetTeam = useCustomInstance<TeamModel>();

  return useCallback(
    (params?: TeamsGetTeamParams, signal?: AbortSignal) => {
      return teamsGetTeam({
        url: `/api/Teams/GetTeam`,
        method: 'GET',
        params,
        signal,
      });
    },
    [teamsGetTeam]
  );
};

export const getTeamsGetTeamQueryKey = (params?: TeamsGetTeamParams) => {
  return [`/api/Teams/GetTeam`, ...(params ? [params] : [])] as const;
};

export const useTeamsGetTeamQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamHook>>>,
  TError = unknown,
>(
  params?: TeamsGetTeamParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTeamsGetTeamQueryKey(params);

  const teamsGetTeam = useTeamsGetTeamHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamHook>>>
  > = ({ signal }) => teamsGetTeam(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TeamsGetTeamQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamHook>>>
>;
export type TeamsGetTeamQueryError = unknown;

export const useTeamsGetTeam = <
  TData = Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamHook>>>,
  TError = unknown,
>(
  params?: TeamsGetTeamParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useTeamsGetTeamQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTeamsGetTeamGroupsHook = () => {
  const teamsGetTeamGroups = useCustomInstance<TeamGroupModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return teamsGetTeamGroups({
        url: `/api/Teams/GetTeamGroups`,
        method: 'GET',
        signal,
      });
    },
    [teamsGetTeamGroups]
  );
};

export const getTeamsGetTeamGroupsQueryKey = () => {
  return [`/api/Teams/GetTeamGroups`] as const;
};

export const useTeamsGetTeamGroupsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamGroupsHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamGroupsHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTeamsGetTeamGroupsQueryKey();

  const teamsGetTeamGroups = useTeamsGetTeamGroupsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamGroupsHook>>>
  > = ({ signal }) => teamsGetTeamGroups(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamGroupsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TeamsGetTeamGroupsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamGroupsHook>>>
>;
export type TeamsGetTeamGroupsQueryError = unknown;

export const useTeamsGetTeamGroups = <
  TData = Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamGroupsHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsGetTeamGroupsHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useTeamsGetTeamGroupsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTeamsCreateTeamGroupHook = () => {
  const teamsCreateTeamGroup = useCustomInstance<number>();

  return useCallback(
    (teamGroupModel: TeamGroupModel) => {
      return teamsCreateTeamGroup({
        url: `/api/Teams/CreateTeamGroup`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: teamGroupModel,
      });
    },
    [teamsCreateTeamGroup]
  );
};

export const useTeamsCreateTeamGroupMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamGroupHook>>>,
    TError,
    { data: TeamGroupModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamGroupHook>>>,
  TError,
  { data: TeamGroupModel },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const teamsCreateTeamGroup = useTeamsCreateTeamGroupHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamGroupHook>>>,
    { data: TeamGroupModel }
  > = (props) => {
    const { data } = props ?? {};

    return teamsCreateTeamGroup(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TeamsCreateTeamGroupMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamGroupHook>>>
>;
export type TeamsCreateTeamGroupMutationBody = TeamGroupModel;
export type TeamsCreateTeamGroupMutationError = unknown;

export const useTeamsCreateTeamGroup = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamGroupHook>>>,
    TError,
    { data: TeamGroupModel },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamGroupHook>>>,
  TError,
  { data: TeamGroupModel },
  TContext
> => {
  const mutationOptions = useTeamsCreateTeamGroupMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useTeamsCreateTeamHook = () => {
  const teamsCreateTeam = useCustomInstance<number>();

  return useCallback(
    (teamModelBody: TeamModelBody) => {
      return teamsCreateTeam({
        url: `/api/Teams/CreateTeam`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: teamModelBody,
      });
    },
    [teamsCreateTeam]
  );
};

export const useTeamsCreateTeamMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamHook>>>,
    TError,
    { data: TeamModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamHook>>>,
  TError,
  { data: TeamModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const teamsCreateTeam = useTeamsCreateTeamHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamHook>>>,
    { data: TeamModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return teamsCreateTeam(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TeamsCreateTeamMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamHook>>>
>;
export type TeamsCreateTeamMutationBody = TeamModelBody;
export type TeamsCreateTeamMutationError = unknown;

export const useTeamsCreateTeam = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamHook>>>,
    TError,
    { data: TeamModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useTeamsCreateTeamHook>>>,
  TError,
  { data: TeamModelBody },
  TContext
> => {
  const mutationOptions = useTeamsCreateTeamMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useTeamsUpdateTeamHook = () => {
  const teamsUpdateTeam = useCustomInstance<boolean>();

  return useCallback(
    (teamModelBody: TeamModelBody) => {
      return teamsUpdateTeam({
        url: `/api/Teams/UpdateTeam`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: teamModelBody,
      });
    },
    [teamsUpdateTeam]
  );
};

export const useTeamsUpdateTeamMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsUpdateTeamHook>>>,
    TError,
    { data: TeamModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useTeamsUpdateTeamHook>>>,
  TError,
  { data: TeamModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const teamsUpdateTeam = useTeamsUpdateTeamHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useTeamsUpdateTeamHook>>>,
    { data: TeamModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return teamsUpdateTeam(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TeamsUpdateTeamMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTeamsUpdateTeamHook>>>
>;
export type TeamsUpdateTeamMutationBody = TeamModelBody;
export type TeamsUpdateTeamMutationError = unknown;

export const useTeamsUpdateTeam = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTeamsUpdateTeamHook>>>,
    TError,
    { data: TeamModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useTeamsUpdateTeamHook>>>,
  TError,
  { data: TeamModelBody },
  TContext
> => {
  const mutationOptions = useTeamsUpdateTeamMutationOptions(options);

  return useMutation(mutationOptions);
};
